import React from 'react'

import Stack from '@mui/material/Stack'

import { P } from '@mxenabled/mxui'

import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface TotalCardProps {
  balance: number | React.ReactNode
  title: string
  sx?: object
}

const TotalCard: React.FC<TotalCardProps> = ({ balance, title, sx }) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.default',
        borderRadius: 2,
        height: 72,
        justifyContent: 'center',
        p: 12,
        ...sx,
      }}
    >
      {typeof balance === 'number' ? (
        <P variant="h2">{formatCurrency(balance, '0,0.00')}</P>
      ) : (
        balance
      )}

      <P color="text.secondary" fontWeight="400" variant="subtitle2">
        {title}
      </P>
    </Stack>
  )
}

export default TotalCard
